<template>
  <div class="login_wrapper">
    <div class="container">
      <div class="box">
        <div class="login">
          <div class="header">
            <div class="title" v-if="+logintype === 1">评审人登录</div>
            <div class="phoneLogin" @click="phoneLogin" v-if="+logintype === 2">评审人登录</div>
          </div>
          <div  v-if="+logintype === 1">
            <div class="form login-input login-select">
              <div class="row">
                <div class="label">账号:</div>
                <div class="value">
                  <el-input placeholder="请输入账号" v-model.trim="model.usercode" clearable></el-input>
                </div>
              </div>
              <div class="row">
                <div class="label">密码:</div>
                <div class="value">
                  <el-input type="password" placeholder="请输入密码" v-model="model.password" clearable></el-input>
                </div>
              </div>
            </div>
            <div class="btn" @click="login">
              <div>登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import request from '../utils/request'
  import { saveTokens } from '../utils/token'
  export default {
    name: "expertLogin",
    data () {
      return {
        role: '',
        options: [],
        imgyzm: '',
        imgyzmToken: '',
        model: {
          usercode: '',
          password: '',
          yzm: ''
        },
        logintype:1,   //1是用户登陆，2是二维码登陆
        dialogVisible: false
      }
    },
    components: {},
    created () {

      this.getYzm()
      if (this.$route.query.t) {
        let local = window.localStorage
        local.clear()
        this.$store.commit('changeState', {'webLoginUser': ''})
      }
      this.getSysCode()
      // let token = location.search ? location.search.substr(1).split('=')[1] : ''
      // console.log(this.$route.query.t)
    },
    methods: {
      phoneLogin () {
        this.logintype = 1
      },
      wechatLogin () {
        this.logintype = 2
      },
      handleClose (done) {
        this.$confirm('确认关闭？')
          .then(() => {
            done();
          })
          .catch(() => {
          });
      },
      getYzm () {
        request({
          method: 'get',
          url: '/validate/getSvgCaptcha',
          data: {}
        }).then((res) => {
          this.imgyzm = res.img
          this.imgyzmToken = res.imgyzmToken
        })
      },
      async getSysCode () {
        this.options = await request({
          url: '/web/web/getSysCodeList',
          method: "get",
          params: {syscode: 'cositemcomtype'}
        })
      },
      async login () {
        // if (!this.role) {
        //   this.$message({
        //     message: '请选择角色！',
        //     type: "warning"
        //   })
        //   return
        // } else
        if (!this.model.usercode) {
          this.$message({
            message: '请输入用户名！',
            type: "warning"
          })
          return
        } else if (!this.model.password) {
          this.$message({
            message: '请输入密码！',
            type: "warning"
          })
          return
        }
        let data = await request({
          url: '/web/web/expertlogin',
          method: 'post',
          data: {
            usercode: this.model.usercode,
            password: this.model.password
          }
        })
        if (data && data.user) {
          delete data.user.userpassword
          let user = data.user
          user.token = data.token
          saveTokens(data.token)
          
          // this.$store.commit('changeState', {'webLoginUser': user})
          // this.$router.push({path: '/'})
          // window.location.replace(`${this.obWebUrl}mainIndex?t=${data.token}`)
          window.location.replace(`${this.obWebUrl}expert?t=${data.token}`)
        } else {
          this.getYzm()
        }
      }
    },
    computed: {
      ...mapGetters(['obWebUrl', 'cosId'])
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';
  .fade-enter-active, .fade-leave-active {
    transition: opacity .15s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .login_wrapper {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("../assets/img/login_bg.png");
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-black;
    overflow-y: hidden;
    .container {
      width: 1201px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: $color-black;
      padding-right: 40px;
      .box {
        border-radius: 3px;
        background-color: $color-bg-white;
        /*设计是425*/
        width: 405px;
        /*20200713*/
        margin: 55px 0;
        .login {
          display: flex;
          flex-direction: column;
          // padding: 0 30px;
          .header{
            display: flex;
            justify-content: space-between;
            margin-left: 30px;
            .title {
              font-size: $fontsize-large-xxx;
              font-weight: bold;
              padding: 35px 0 20px;
            }
            .phoneLogin{
              cursor: pointer;
              font-size: 18px;
              margin:27px 10px 0 0;
            }
            .phoneLogin:hover{
              // text-decoration: underline
            }
            .wechat{
              cursor: pointer;
            }
          }
          .form {
            font-size: $fontsize-medium;
            /*设计图是40px 20200713*/
            // padding-bottom: 5px;
            padding: 0 30px 20px 30px;
            .row {
              display: flex;
              align-items: center;
              border-bottom: 1px solid $color-line-gray;
              /*20200713*/
              padding: 10px 0;
              /*设计图是40px 20200713*/
              margin-bottom: 15px;
              .label {
                width: 60px;
              }
              .value {
                flex: 1;
              }
              .yzmbtn {
                color: $color-orange;
                cursor: pointer;
                font-size: $fontsize-medium-s;
              }
            }
            .wechat-box{
              // display: flex;
              // justify-content: center;
              // margin:70px auto;
              .wechat-code{
                width: 300px;
                height: 400px;
                margin:0 auto;
                // background-color: #000;
              }
              .wechat_text{
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top:10px;
                i {
                  display: inline-block;
                  width: 18px;
                  height: 18px;
                  background-size: 18px 18px;
                  background-image: url('../assets/img/wechatlogo.png');
                }
                .text{
                  display: inline-block;
                  margin-left: 10px;
                }
              }
            }
          }
          .btn {
            text-align: center;
            border-radius: 40px;
            background-color: $color-orange;
            padding: 16px;
            margin: 10px 30px 30px;
            font-size: $fontsize-large-x;
            color: #fff;
            cursor: pointer;
          }
          .lead {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: $fontsize-medium;
            /*设计图是padding: 30px 0 40px;*/
            padding: 20px 30px 20px 30px;
            span{
              cursor: pointer;
              color: $color-orange;
              border-bottom: 1px solid $color-orange;
            }
            & :first-child {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
</style>